import React, { useState, useEffect } from 'react';
// import AddEventiteam
import AddEventiteam from './AddEventiteam'
import AddMeasured from './AddMeasured';
import Comment from './Comment';
import { get, post } from '../../ApiServices/ApiServices';
import { toast, ToastContainer } from 'react-toastify';
import Container from '../../Container/Container';
import 'react-toastify/dist/ReactToastify.css';
import { useForm } from "react-hook-form";
import { setSize, clearSize, setShirtSize, setAccountData } from '../../redux/profileSlice';
import {
    fetchSingleOrderStart,
    fetchSingleOrderSuccess,
    fetchSingleOrderFailure
} from '../../redux/singleOrderSlice';
import { useDispatch, useSelector } from 'react-redux';
import OrderReview from './OrderReview';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import SingleOrder from './SingleOrder';
import Loader from '../Component/Loader';
import moment from 'moment';
function MultipleForm() {

    const [step, setStep] = useState(1);
    const [Helper, setHelper] = useState(false);
    const [id, setid] = useState(null)
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch();
    const ID = location.state?.ID;
    const Help = location.state?.Helper

    console.log(location?.pathname == "/update-single-order", "location?.pathname")

    useEffect(() => {
        if (Help) {
            setHelper(Help)
        }
    }, [Help])


    const [showShirt, setShowShirt] = useState(true);
    const [showVest, setShowVest] = useState(true);
    const [showShoes, setShowShoes] = useState(true);
    const [showTie, setShowTie] = useState(true)
    const [Showjewelry, setShowjewelry] = useState(true)
    const [ShowPocket, setShowPocket] = useState(true)
    const [Showcoat, setShowcoat] = useState(true)
    const [ShowPant, setShowPant] = useState(true)
    const [Singledata, setSingledata] = useState([])
    const [CopyOrder, setCopyOrder] = useState(false)
    const [loading, setLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { setValue } = useForm();


    const profile = useSelector((state) => state.profile.profile);

    const previousPath = location.state?.from; // Will be '/dashboard'
    console.log(previousPath, "previousPathpreviousPath-----------")

    const Singleorder = async () => {
        try {
            setLoading(true); // Start loading

            const api = `view-single-order/${ID}`;
            const response = await get(api);
            if (response?.status == true) {
                dispatch(fetchSingleOrderSuccess({
                    data: response.data,
                    id: response.data.id
                }));
                setSingledata(response?.data);
                setid(response?.data?.id)
            }
        } catch (err) {
            console.error('Error:', err);
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        }
        finally {
            setLoading(false); // Stop loading regardless of success/error
        }
    };
    if (!ID) {
        setTimeout(() => setLoading(false), 1000);

    }

    useEffect(() => {
        if (ID) {
            Singleorder()
        }
    }, [ID])
    const { single_order_style = [] } = Singledata;
    console.log(Singledata, "Singledata", single_order_style, "single_order_style");

    const coat = single_order_style.find(item => item.inventory_category_type === "Coats");
    const pant = single_order_style.find(item => item.inventory_category_type === "Pants");
    const shirt = single_order_style.find(item => item.inventory_category_type === "Shirt");
    const vest = single_order_style.find(item => item.inventory_category_type === "Vests");
    const tie = single_order_style.find(item => item.inventory_category_type === "Ties");
    const pocketSquare = single_order_style.find(item => item.inventory_category_type === "PocketSquare");
    const jewellery = single_order_style.find(item => item.inventory_category_type === "Jewellery");
    const shoes = single_order_style.find(item => item.inventory_category_type === "Shoes");




    useEffect(() => {
        const serializedData = JSON.stringify(coat?.inventory_category?.inventories[0]);
        localStorage.setItem('coatStyle', serializedData);
        // localStorage.setItem('coatid', coat?.size);
        localStorage.setItem('selectedCoatSize', coat?.size);


        console.log(coat?.size_chart_category_id, "coat?.size_chart_category_id")
        localStorage.setItem('size', coat?.size_chart_category_id);

    }, [coat])

    useEffect(() => {
        const serializedData = JSON.stringify(shirt?.inventory_category?.inventories[0]);
        localStorage.setItem('shirtstyle', serializedData);
        localStorage.setItem('size', shirt?.size_chart_category_id);

    }, [shirt])

    useEffect(() => {
        const serializedData = JSON.stringify(pant?.inventory_category?.inventories[0]);
        localStorage.setItem('pantstyle', serializedData);
        localStorage.setItem('size', pant?.size_chart_category_id);

    }, [pant])

    useEffect(() => {
        const serializedData = JSON.stringify(vest?.inventory_category?.inventories[0]);
        localStorage.setItem('Veststyle', serializedData);
        localStorage.setItem('size', vest?.size_chart_category_id);

    }, [vest])


    useEffect(() => {
        const serializedData = JSON.stringify(shoes?.inventory_category?.inventories[0]);
        localStorage.setItem('Shoes', serializedData);
        // localStorage.setItem('size', vest?.size_chart_category_id);

    }, [shoes])

    // console.log(orderData, "orderDataorderDataorderData");

    function convertHeightToInches(height) {
        if (!height) return ""; // Return empty string if height is not provided
        console.log('Converting height:', height); // Log the height value

        // Split the height string into feet and inches parts
        const parts = height.split(/'|"/);
        const feet = parseInt(parts[0]) || 0;
        const inches = parseInt(parts[1]) || 0;

        // Calculate total inches
        const totalInches = feet * 12 + inches;
        return totalInches;
    }

    // Example usage:

    const height = Singledata.height;
    const heightInInches = convertHeightToInches(height); // Returns 63
    useEffect(() => {
        if (Singledata) {
            console.log("Singledata:", Singledata);

            const heightInInches = convertHeightToInches(Singledata.height); // Assuming Singledata.height is the input height.
            const sizeCategoryId = coat?.size_chart_category_id ||
                pant?.size_chart_category_id ||
                shirt?.size_chart_category_id || "";

            const sizeChartId = coat?.size_chart_id ||
                pant?.size_chart_id ||
                shirt?.size_chart_id || "";
            console.log('Singledata.height:', Singledata.height); // Log height value
            setFormData(prev => ({
                ...prev,
                // Personal Details
                Weddingdate: Helper == false ? (Singledata.event_date || "") : "",
                order_for: Singledata.order_for || "Men",
                ordertype: Singledata.order_type || "",
                Firstname: Singledata.first_name || "",
                Lastname: Singledata.last_name || "",
                Address: Singledata.address || "",
                State: Singledata.state || "",
                City: Singledata.city || "",
                ZipCode: Singledata.zip_code || "",
                PhoneNumber: Singledata.phone || "",
                EmailAddress: Singledata.email || "",
                school: Singledata.school || "",
                belt: pant?.belt || "",
                order_type: Singledata.order_type || "",
                AlternatePickup: Singledata.is_alt_pickup_enable,
                Affiliated_store: Singledata.store,


                AlterAcc: Singledata?.account,
                AccountId: Singledata?.user_id,
                dropShippingswitch: Singledata.is_drop_ship_enable,

                dropShipping: {
                    name: Singledata.name,
                    addressLine1: Singledata.shipping_address,
                    addressLine2: Singledata.shipping_address_line2,
                    city: Singledata.shipping_city,
                    state: Singledata.shipping_state,
                    zipCode: Singledata.shipping_zip,
                    phone: Singledata.shipping_phone,
                },


                // Height: heightInInches || "",
                Height: heightInInches === 0 ? "Unknown" : heightInInches,
                Weight: Singledata?.weight || "",
                Chest: Singledata?.chest || "",
                Overarm: Singledata?.overarm || "",

                Coat: coat?.style || "",
                CoatSize: coat?.size || "",
                // size_chart_category_id: Singledata.size_chart_category_id || "",
                Insleeve: coat?.insleeve || localStorage.getItem("Insleeve") || "",

                size_chart_category_id: sizeCategoryId,
                coat_size_chart_id: coat?.size_chart_id || "",

                belt: pant?.belt || "",
                Pant: pant?.style || "",
                Waist: pant?.size || "",
                hip: pant?.hip || "",
                outseam: pant?.outseam || "",
                belt: pant?.belt || "",
                Shirt: shirt?.style || "",
                ShirtSize: shirt?.size || "",
                shirt_size: shirt?.shirt_size || "",
                Sleeve: shirt?.sleeve || "",

                Vest: vest?.style || "",
                VestColor: vest?.size || "",


                Tie: tie?.style || "",
                Pocket: pocketSquare?.style || "",
                Jewelry: jewellery?.style || "",
                Shoes: shoes?.style || "",
                ShoesSize: shoes?.size || "",
                shoe_color: shoes?.inventory_category.inventories[0].shoe_color,
                Rentalterm: Singledata?.rental_term || "",
                Notes: Singledata?.comments || "",
                SubmittedBy: Singledata.measured_by || "",
                // Add other fields from Singledata as needed


                coatinventory_id: coat?.inventory_id || "",
                Paintinventory_id: pant?.inventory_id || "",
                shirtInventory_id: shirt?.inventory_id || "",
                VestInventory_id: vest?.inventory_id || "",
                TieInventory_id: tie?.inventory_id || "",
                PocketInventory_id: pocketSquare?.inventory_id || "",
                jewelryinventory_id: jewellery?.inventory_id || "",
                ShoesInventory_id: shoes?.inventory_id || "",
            }));
        }
    }, [Singledata]); // This effect runs when Singledata changes


    console.log(coat?.size_chart_id, "Singledata?.size_chart_category_id ")
    const [formData, setFormData] = useState({
        // Personal Details
        Weddingdate: Helper == false ? (Singledata.event_date || "") : "",
        ordertype: Singledata.order_type || "",
        Firstname: Singledata.first_name || "",
        Lastname: Singledata.last_name || "",
        Address: Singledata.address || "",
        State: Singledata.state || "",
        City: Singledata.city || "",
        ZipCode: Singledata.zip_code || "",
        PhoneNumber: Singledata.phone || "",
        EmailAddress: Singledata.email || "",
        school: Singledata.school || "",
        belt: pant?.belt || "",
        shirtSizetype: null,


        size_chart_id: "",
        order_for: Singledata.order_for || "Men",
        order_type: Singledata.order_type || "",
        AlterAcc: "",
        AccountId: null,

        Affiliated_store: "",
        store_id: null,
        is_logging: "false",
        // Drop Shipping
        dropShippingswitch: false,
        dropShipping: {
            name: Singledata.name || "",
            addressLine1: Singledata.shipping_address || "",
            addressLine2: Singledata.shipping_address_line2 || "",
            city: Singledata.shipping_city || "",
            state: Singledata.shipping_state || "",
            phone: Singledata.shipping_phone || "",
        },

        // Measurements
        Height: heightInInches || "",
        Weight: Singledata?.weight || "",
        Weightwo: "",
        Overarm: Singledata?.overarm || "",
        Coat: coat?.style || "",
        CoatSize: coat?.size || "",
        // Insleeve: "",
        Insleeve: Singledata?.insleeve || localStorage.getItem("Insleeve") || "",

        Pant: pant?.style,
        PantSize: "",
        Shirt: shirt?.style || "",
        ShirtSize: shirt?.size || "",
        shirt_size: shirt?.shirt_size || "",
        Sleeve: shirt?.Sleeve || "",
        Vest: vest?.style || "",
        VestColor: vest?.size || "",
        outseam: pant?.outseam || "",
        Chest: Singledata?.chest || "",
        Tie: tie?.style || "",
        hip: pant?.hip || "",
        Pocket: pocketSquare?.style || "",
        Jewelry: jewellery?.style || "",
        Shoes: shoes?.style || "",
        ShoesSize: shoes?.size || "",
        style: "",
        Waist: pant?.size,
        Rentalterm: Singledata?.rental_term || "",

        // Other fields
        AlternatePickup: false,
        Affiliated_store: "",


        // Inventory IDs
        coatinventory_id: coat?.inventory_id || "",
        Paintinventory_id: pant?.inventory_id || "",
        shirtInventory_id: shirt?.inventory_id || "",
        VestInventory_id: vest?.inventory_id || "",
        TieInventory_id: tie?.inventory_id || "",
        PocketInventory_id: pocketSquare?.inventory_id || "",
        jewelryinventory_id: jewellery?.inventory_id || "",
        ShoesInventory_id: shoes?.inventory_id || "",
        // size_chart_category_id: "",
        size_chart_category_id: Singledata?.size_chart_category_id || "",
        coat_size_chart_id: coat?.size_chart_id || "",


        // Description
        Notes: Singledata.comments || "",
        SubmittedBy: Singledata.measured_by || "",
        NextSlip: ""
    });

    const onNextStep = (data) => {
        console.log(data, "data+++)")
        setFormData(prevData => ({
            ...prevData,
            ...data
        }));
        dispatch(setAccountData(data.AlterAcc));
        console.log(data.AlterAcc, "data.AlterAccdata.AlterAcc");
        setStep(step + 1);
    };

    const onBackStep = () => {
        setStep(step - 1);
    };
    function convertInchesToFeet(inches) {
        if (!inches || isNaN(inches)) return `0'0"`; // Handle invalid inputs
        let feet = Math.floor(inches / 12);  // Get whole feet
        let remainingInches = inches % 12;   // Get remaining inches

        return `${feet}'${remainingInches}"`; // Format as 6'4"
    }

    const orderData = useSelector(state => state.singleOrder.data);

    const onFormSubmit = async (addressData) => {
        setIsSubmitting(true);
        const { single_order_style = [] } = orderData || {};
        const coat = single_order_style.find(item => item.inventory_category_type === "Coats") || null;
        const pant = single_order_style.find(item => item.inventory_category_type === "Pants") || null;
        const shirt = single_order_style.find(item => item.inventory_category_type === "Shirt") || null;
        const vest = single_order_style.find(item => item.inventory_category_type === "Vests") || null;
        const tie = single_order_style.find(item => item.inventory_category_type === "Ties") || null;
        const pocketSquare = single_order_style.find(item => item.inventory_category_type === "PocketSquare") || null;
        const jewellery = single_order_style.find(item => item.inventory_category_type === "Jewellery") || null;
        const shoes = single_order_style.find(item => item.inventory_category_type === "Shoes") || null;

        setFormData(prevData => ({
            ...prevData,
            ...addressData
        }));
        const finalData = {
            ...formData,
            ...addressData
        };


        let heightInInches = 65; // Example: 65 inches
        let convertedHeight = convertInchesToFeet(finalData?.Height);
        console.log(finalData, "finalData");

        const data = {
            is_logging: "false",
            event_date: finalData?.Weddingdate,
            weekend_date: moment(finalData?.Weddingdate).isoWeekday(6).format("MMM D, YYYY"),
            first_name: finalData?.Firstname,
            last_name: finalData?.Lastname,
            address: finalData?.Address,
            state: finalData?.State,
            city: finalData?.City,
            zip_code: finalData?.ZipCode,
            phone: finalData?.PhoneNumber,
            email: finalData?.EmailAddress,
            school: finalData?.order_type == "Prom Order" ? finalData?.school : "",
            is_alt_pickup_enable: finalData?.AlternatePickup || false,
            is_drop_ship_enable: finalData?.dropShippingswitch || false,
            name: finalData?.dropShipping?.name,
            shipping_address: finalData?.dropShipping?.addressLine1,
            shipping_address_line2: finalData?.dropShipping?.addressLine2,
            shipping_city: finalData?.dropShipping?.city,
            shipping_state: finalData?.dropShipping?.state,
            shipping_zip: finalData?.dropShipping?.zipCode,
            shipping_phone: finalData?.dropShipping?.phone,
            height: convertedHeight,
            weight: finalData?.Weight,
            chest: finalData?.Chest,
            overarm: finalData?.Overarm,
            rental_term: finalData?.Rentalterm,
            order_for: finalData?.order_for,
            measured_by: finalData?.SubmittedBy,
            comments: finalData?.Notes,
            order_type: finalData?.order_type,
            store: finalData?.Affiliated_store,
            store_id: finalData?.store_id,
            status_id: 1,
            ...(profile?.name == "Admin" && {
                user_id: finalData?.AccountId || null,
            }),
            account: finalData?.AlterAcc || profile?.account,

            stylesData: [
                finalData?.Coat && {
                    inventory_category_id: 1,
                    inventory_category_type: "Coats",
                    inventory_id: finalData?.coatinventory_id,
                    style: finalData?.Coat,
                    size_chart_category_id: isNaN(parseInt(finalData?.size_chart_category_id))
                        ? finalData?.size_chart_category_id
                        : parseInt(finalData?.size_chart_category_id) || null,
                    size_chart_id: finalData?.coat_size_chart_id || null,
                    size: finalData?.CoatSize,
                    insleeve: String(finalData.Insleeve)
                },




                finalData?.Pant && {

                    // ...(pant && { id: pant.id }),
                    inventory_category_id: 2,
                    inventory_id: finalData?.Paintinventory_id,
                    inventory_category_type: "Pants",
                    style: finalData?.Pant,
                    size_chart_category_id: isNaN(parseInt(finalData?.size_chart_category_id))
                        ? finalData?.size_chart_category_id
                        : parseInt(finalData?.size_chart_category_id) || null,
                    size_chart_id: finalData?.coat_size_chart_id || null,
                    size: finalData?.Waist,
                    hip: String(finalData.hip),
                    belt: finalData.belt || null,
                    outseam: String(finalData.outseam)
                },



                finalData?.Shirt && {
                    // ...(shirt && { id: shirt.id }),

                    inventory_category_id: 3,
                    inventory_id: finalData?.shirtInventory_id,
                    inventory_category_type: "Shirt",
                    style: finalData?.Shirt,
                    size_chart_category_id: isNaN(parseInt(finalData?.size_chart_category_id))
                        ? finalData?.size_chart_category_id
                        : parseInt(finalData?.size_chart_category_id) || null,
                    size_chart_id: finalData?.coat_size_chart_id || null,
                    size: finalData?.ShirtSize,
                    shirt_size: finalData?.shirt_size,


                    sleeve: String(finalData.Sleeve)
                },
                // finalData?.Vest &&

                finalData?.Vest && {

                    // ...(vest && { id: vest.id }),
                    inventory_category_id: 4,
                    inventory_id: finalData?.VestInventory_id,
                    inventory_category_type: "Vests",
                    style: finalData?.Vest,
                    size_chart_category_id: isNaN(parseInt(finalData?.size_chart_category_id))
                        ? finalData?.size_chart_category_id
                        : parseInt(finalData?.size_chart_category_id) || null,
                    size_chart_id: finalData?.coat_size_chart_id || null,
                    size: finalData?.VestColor
                },
                // finalData?.Tie

                finalData?.Tie && {
                    // ...(tie && { id: tie.id }),

                    inventory_category_id: 5,
                    inventory_category_type: "Ties",
                    inventory_id: finalData?.TieInventory_id,

                    style: finalData?.Tie
                },
                // finalData?.Pocket &&

                finalData?.Pocket && {
                    // ...(pocketSquare && { id: pocketSquare.id }),
                    inventory_category_id: 8,
                    inventory_category_type: "PocketSquare",
                    inventory_id: finalData?.PocketInventory_id,
                    style: finalData?.Pocket
                },
                // finalData?.Jewelry &&


                finalData?.Jewelry && {
                    inventory_category_id: 9,
                    inventory_category_type: "Jewellery",
                    inventory_id: finalData?.jewelryinventory_id,
                    style: finalData?.Jewelry
                },
                // finalData?.Shoes &&

                finalData?.Shoes && {
                    // ...(shoes && { id: shoes.id }),

                    inventory_category_id: 7,
                    inventory_category_type: "Shoes",
                    inventory_id: finalData?.ShoesInventory_id,
                    style: finalData?.Shoes,
                    size_chart_category_id: isNaN(parseInt(finalData?.size_chart_category_id))
                        ? finalData?.size_chart_category_id
                        : parseInt(finalData?.size_chart_category_id) || null,
                    size_chart_id: finalData?.coat_size_chart_id || null,
                    size: finalData?.ShoesSize
                }
            ].filter(Boolean) // Filter out falsy values
        };
        const updata = {
            is_logging: "true",
            event_date: finalData?.Weddingdate,
            weekend_date: moment(finalData?.Weddingdate).isoWeekday(6).format("MMM D, YYYY"),
            first_name: finalData?.Firstname,
            last_name: finalData?.Lastname,
            address: finalData?.Address,
            state: finalData?.State,
            city: finalData?.City,
            zip_code: finalData?.ZipCode,
            phone: finalData?.PhoneNumber,
            email: finalData?.EmailAddress,
            school: finalData?.order_type == "Prom Order" ? finalData?.school : "",

            is_alt_pickup_enable: finalData?.AlternatePickup || false,
            is_drop_ship_enable: finalData?.dropShippingswitch || false,
            name: finalData?.dropShipping?.name,
            shipping_address: finalData?.dropShipping?.addressLine1,
            shipping_address_line2: finalData?.dropShipping?.addressLine2,
            shipping_city: finalData?.dropShipping?.city,
            shipping_state: finalData?.dropShipping?.state,
            shipping_zip: finalData?.dropShipping?.zipCode,
            shipping_phone: finalData?.dropShipping?.phone,
            height: convertedHeight,
            weight: finalData?.Weight,
            chest: finalData?.Chest,
            overarm: finalData?.Overarm,
            rental_term: finalData?.Rentalterm,
            order_for: finalData?.order_for,
            measured_by: finalData?.SubmittedBy,
            comments: finalData?.Notes,
            order_type: finalData?.order_type,
            store: finalData?.Affiliated_store,
            store_id: finalData?.store_id,


            status_id:
                orderData?.status?.name == "pending" && step == 4
                    ? 2
                    : undefined,

            // status_id: step == 4 ? 2 : orderData?.status_id,

            ...(profile?.name == "Admin" && {
                user_id: finalData?.AccountId,
            }),
            account: finalData?.AlterAcc || profile?.account,


            stylesData: [
                (coat && !finalData?.Coat) ? {
                    "id": coat.id,
                    "isDeleted": true
                }
                    :
                    finalData?.Coat && {
                        // (!finalData?.Coat && coat) ?
                        // ( finalData?.coatinventory_id == inventory_id || finalData?.Coat == style || finalData?.coat_size_chart_id == size_chart_id || finalData?.CoatSize == size || finalData?.insleeve == insleeve )
                        ...(coat ? { id: coat.id } : {}),
                        inventory_category_id: 1,
                        inventory_category_type: "Coats",
                        inventory_id: finalData?.coatinventory_id,
                        style: finalData?.Coat,
                        size_chart_category_id: finalData.size_chart_category_id
                            ? parseInt(finalData.size_chart_category_id)
                            : null,
                        size_chart_id: finalData?.coat_size_chart_id || null,
                        size: finalData?.CoatSize,
                        insleeve: String(finalData.Insleeve)
                    },



                (pant && !finalData?.Pant) ? {
                    "id": pant.id,
                    "isDeleted": true
                }
                    :
                    finalData?.Pant && {
                        ...(pant ? { id: pant.id } : {}),
                        // ...(pant && { id: pant.id }),
                        inventory_category_id: 2,
                        inventory_id: finalData?.Paintinventory_id,
                        inventory_category_type: "Pants",
                        style: finalData?.Pant,
                        size_chart_category_id: isNaN(parseInt(finalData?.size_chart_category_id))
                            ? finalData?.size_chart_category_id
                            : parseInt(finalData?.size_chart_category_id) || null,
                        size_chart_id: finalData?.coat_size_chart_id || null,
                        size: finalData?.Waist,
                        belt: finalData?.belt,
                        hip: String(finalData.hip),
                        outseam: String(finalData.outseam)
                    },


                (shirt && !finalData?.Shirt) ? {
                    "id": shirt.id,
                    "isDeleted": true
                }
                    : finalData?.Shirt && {
                        // ...(shirt && { id: shirt.id }),
                        ...(shirt ? { id: shirt.id } : {}),

                        inventory_category_id: 3,
                        inventory_id: finalData?.shirtInventory_id,
                        inventory_category_type: "Shirt",
                        style: finalData?.Shirt,
                        size_chart_category_id: isNaN(parseInt(finalData?.size_chart_category_id))
                            ? finalData?.size_chart_category_id
                            : parseInt(finalData?.size_chart_category_id) || null,
                        size_chart_id: finalData?.coat_size_chart_id || null,
                        size: finalData?.ShirtSize,
                        shirt_size: finalData?.shirt_size,
                        sleeve: String(finalData.Sleeve)
                    },
                // finalData?.Vest &&
                (vest && !finalData?.Vest) ? {
                    "id": vest.id,
                    "isDeleted": true
                }
                    :
                    finalData?.Vest && {
                        ...(vest ? { id: vest.id } : {}),

                        // ...(vest && { id: vest.id }),
                        inventory_category_id: 4,
                        inventory_id: finalData?.VestInventory_id,
                        inventory_category_type: "Vests",
                        style: finalData?.Vest,
                        size_chart_category_id: isNaN(parseInt(finalData?.size_chart_category_id))
                            ? finalData?.size_chart_category_id
                            : parseInt(finalData?.size_chart_category_id) || null,
                        size_chart_id: finalData?.coat_size_chart_id || null,
                        size: finalData?.VestColor
                    },
                // finalData?.Tie

                (tie && !finalData?.Tie) ? {
                    "id": tie.id,
                    "isDeleted": true
                }
                    : finalData?.Tie && {
                        // ...(tie && { id: tie.id }),
                        ...(tie ? { id: tie.id } : {}),

                        inventory_category_id: 5,
                        inventory_category_type: "Ties",
                        inventory_id: finalData?.TieInventory_id,

                        style: finalData?.Tie
                    },
                // finalData?.Pocket &&

                (pocketSquare && !finalData?.Pocket) ? {
                    "id": pocketSquare.id,
                    "isDeleted": true
                }
                    :
                    finalData?.Pocket && {
                        // ...(pocketSquare && { id: pocketSquare.id }),
                        ...(pocketSquare ? { id: pocketSquare.id } : {}),

                        inventory_category_id: 8,
                        inventory_category_type: "PocketSquare",
                        inventory_id: finalData?.PocketInventory_id,
                        style: finalData?.Pocket
                    },
                // finalData?.Jewelry &&


                (jewellery && !finalData?.Jewelry) ? {
                    "id": jewellery.id,
                    "isDeleted": true
                }
                    : finalData?.Jewelry && {
                        // ...(jewellery && { id: jewellery.id }),
                        ...(jewellery ? { id: jewellery.id } : {}),

                        inventory_category_id: 9,
                        inventory_category_type: "Jewellery",
                        inventory_id: finalData?.jewelryinventory_id,
                        style: finalData?.Jewelry
                    },
                // finalData?.Shoes &&


                (shoes && !finalData?.Shoes) ? {
                    "id": shoes.id,
                    "isDeleted": true
                }
                    : finalData?.Shoes && {
                        // ...(shoes && { id: shoes.id }),
                        ...(shoes ? { id: shoes.id } : {}),

                        inventory_category_id: 7,
                        inventory_category_type: "Shoes",
                        inventory_id: finalData?.ShoesInventory_id,
                        style: finalData?.Shoes,
                        size_chart_category_id: isNaN(parseInt(finalData?.size_chart_category_id))
                            ? finalData?.size_chart_category_id
                            : parseInt(finalData?.size_chart_category_id) || null,
                        size_chart_id: finalData?.coat_size_chart_id || null,
                        size: finalData?.ShoesSize
                    }
            ].filter(Boolean) // Filter out falsy values
        };


        if (CopyOrder == false) {
            try {
                // alert(false)
                const api = (id && Helper == false) ? `update-single-order/${id}` : 'create-single-order'
                const totalData = await post(api, ((id || ID) && Helper == false) ? updata : data);
                console.log(totalData, "totalData",)
                // setid(totalData?.data?.id)

                // setSingledata([])
                if (!id || Helper == true) {
                    setid(totalData?.data?.id)
                }
                if (step == 4) {
                    navigate("/single-order")
                }
                else {
                    setStep(step + 1);

                }

                setHelper(false)
                setShowShirt(true)
                setShowTie(true)
                setShowVest(true)
                setShowShoes(true)
                setShowPocket(true)
                setShowjewelry(true)
                setShowcoat(true)
                setShowPant(true)
                toast.success(totalData?.message, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    closeButton: false,
                });
                setFormData(prevData => ({
                    ...prevData,
                    ...data
                }));
                setIsSubmitting(false);
            }
            catch (error) {
                console.log(error, "error");
                toast.error(error.message || 'Failed to submit form. Please try again.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    closeButton: false,
                });
                setIsSubmitting(false);
            }
        }
        else {
            try {
                const Copydata = {
                    is_logging: "false",
                    event_date: finalData?.Weddingdate,
                    weekend_date: moment(finalData?.Weddingdate).isoWeekday(6).format("MMM D, YYYY"),
                    first_name: finalData?.Firstname,
                    last_name: finalData?.Lastname,
                    address: finalData?.Address,
                    state: finalData?.State,
                    city: finalData?.City,
                    zip_code: finalData?.ZipCode,
                    phone: finalData?.PhoneNumber,
                    email: finalData?.EmailAddress,
                    school: finalData?.order_type == "Prom Order" ? finalData?.school : "",
                    is_alt_pickup_enable: finalData?.AlternatePickup || false,
                    is_drop_ship_enable: finalData?.dropShippingswitch || false,
                    name: finalData?.dropShipping?.name,
                    shipping_address: finalData?.dropShipping?.addressLine1,
                    shipping_address_line2: finalData?.dropShipping?.addressLine2,
                    shipping_city: finalData?.dropShipping?.city,
                    shipping_state: finalData?.dropShipping?.state,
                    shipping_zip: finalData?.dropShipping?.zipCode,
                    shipping_phone: finalData?.dropShipping?.phone,
                    height: convertedHeight,
                    weight: finalData?.Weight,
                    chest: finalData?.Chest,
                    overarm: finalData?.Overarm,
                    rental_term: finalData?.Rentalterm,
                    order_for: finalData?.order_for,
                    measured_by: finalData?.SubmittedBy,
                    comments: finalData?.Notes,
                    order_type: finalData?.order_type,
                    store: finalData?.Affiliated_store,
                    store_id: finalData?.store_id,
                    status_id: 1,
                    ...(profile?.name == "Admin" && {
                        user_id: finalData?.AccountId || null,
                    }),
                    account: finalData?.AlterAcc || profile?.account,

                    stylesData: [
                        finalData?.Coat && {
                            inventory_category_id: 1,
                            inventory_category_type: "Coats",
                            inventory_id: finalData?.coatinventory_id,
                            style: finalData?.Coat,
                            size_chart_category_id: isNaN(parseInt(finalData?.size_chart_category_id))
                                ? finalData?.size_chart_category_id
                                : parseInt(finalData?.size_chart_category_id) || null,
                            size_chart_id: finalData?.coat_size_chart_id || null,
                            size: finalData?.CoatSize,
                            insleeve: String(finalData.Insleeve)
                        },




                        finalData?.Pant && {

                            // ...(pant && { id: pant.id }),
                            inventory_category_id: 2,
                            inventory_id: finalData?.Paintinventory_id,
                            inventory_category_type: "Pants",
                            style: finalData?.Pant,
                            size_chart_category_id: isNaN(parseInt(finalData?.size_chart_category_id))
                                ? finalData?.size_chart_category_id
                                : parseInt(finalData?.size_chart_category_id) || null,
                            size_chart_id: finalData?.coat_size_chart_id || null,
                            size: finalData?.Waist,
                            hip: String(finalData.hip),
                            belt: finalData.belt || null,
                            outseam: String(finalData.outseam)
                        },



                        finalData?.Shirt && {
                            // ...(shirt && { id: shirt.id }),

                            inventory_category_id: 3,
                            inventory_id: finalData?.shirtInventory_id,
                            inventory_category_type: "Shirt",
                            style: finalData?.Shirt,
                            size_chart_category_id: isNaN(parseInt(finalData?.size_chart_category_id))
                                ? finalData?.size_chart_category_id
                                : parseInt(finalData?.size_chart_category_id) || null,
                            size_chart_id: finalData?.coat_size_chart_id || null,
                            size: finalData?.ShirtSize,
                            shirt_size: finalData?.shirt_size,
                            sleeve: String(finalData.Sleeve)
                        },
                        // finalData?.Vest &&

                        finalData?.Vest && {

                            // ...(vest && { id: vest.id }),
                            inventory_category_id: 4,
                            inventory_id: finalData?.VestInventory_id,
                            inventory_category_type: "Vests",
                            style: finalData?.Vest,
                            size_chart_category_id: isNaN(parseInt(finalData?.size_chart_category_id))
                                ? finalData?.size_chart_category_id
                                : parseInt(finalData?.size_chart_category_id) || null,
                            size_chart_id: finalData?.coat_size_chart_id || null,
                            size: finalData?.VestColor
                        },
                        // finalData?.Tie

                        finalData?.Tie && {
                            // ...(tie && { id: tie.id }),
                            inventory_category_id: 5,
                            inventory_category_type: "Ties",
                            inventory_id: finalData?.TieInventory_id,
                            style: finalData?.Tie
                        },

                        finalData?.Pocket && {
                            // ...(pocketSquare && { id: pocketSquare.id }),

                            inventory_category_id: 8,
                            inventory_category_type: "PocketSquare",
                            inventory_id: finalData?.PocketInventory_id,
                            style: finalData?.Pocket
                        },
                        // finalData?.Jewelry &&


                        finalData?.Jewelry && {

                            inventory_category_id: 9,
                            inventory_category_type: "Jewellery",
                            inventory_id: finalData?.jewelryinventory_id,
                            style: finalData?.Jewelry
                        },
                        // finalData?.Shoes &&

                        finalData?.Shoes && {
                            // ...(shoes && { id: shoes.id }),

                            inventory_category_id: 7,
                            inventory_category_type: "Shoes",
                            inventory_id: finalData?.ShoesInventory_id,
                            style: finalData?.Shoes,
                            size_chart_category_id: isNaN(parseInt(finalData?.size_chart_category_id))
                                ? finalData?.size_chart_category_id
                                : parseInt(finalData?.size_chart_category_id) || null,
                            size_chart_id: finalData?.coat_size_chart_id || null,
                            size: finalData?.ShoesSize
                        }
                    ].filter(Boolean) // Filter out falsy values
                };
                const api = 'create-single-order'
                const totalData = await post(api, Copydata);
                setCopyOrder(false)
                toast.success(totalData?.message, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    closeButton: false,
                });
                setIsSubmitting(false);
            }
            catch (error) {
                console.log(error, "error");
                toast.error(error.message || 'Failed to submit form. Please try again.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    closeButton: false,
                });
                setIsSubmitting(false);

            }
        }



    };


    const onFinalSubmit = async () => {
        setIsSubmitting(true);

        // alert("final submit check aadil")
        // console.log("Final submit clicked!");
        try {
            let api;
            let Data;
            let convertedHeight = convertInchesToFeet(formData?.Height);


            // if (location?.pathname == "/add-order") {
            if (showShirt && showVest && showShoes && showTie && Showjewelry && ShowPocket && Showcoat && ShowPant) {
                // If all items are shown, confirm the order
                api = id ? `confirm-single-order/${id}` : '';
                Data = {
                    status_id: 2 // Assuming 2 is the status for confirmed orders
                };
                var totalData = await post(api, Data);

            } else {
                // If any item is hidden, update the order with the current data
                onFormSubmit()
            }

            navigate("/single-order")
            toast.success(totalData?.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                closeButton: false,
            });

            setFormData({
                // Personal Details
                Weddingdate: "",
                ordertype: "",
                Firstname: "",
                Lastname: "",
                Address: "",
                State: "",
                City: "",
                ZipCode: "",
                phoneNumber: "",
                EmailAddress: "",
                school: "",
                size_chart_id: "",
                order_for: "Men",
                order_type: "",
                AlterAcc: "",
                AccountId: null,

                store_id: null,
                shirtSizetype: null,

                // Drop Shipping
                dropShippingswitch: false,
                dropShipping: {
                    name: "",
                    addressLine1: "",
                    addressLine2: "",
                    city: "",
                    state: "",
                    zipCode: "",
                    phone: ""
                },

                // Measurements
                Height: "",
                Weight: "",
                Weightwo: "",
                Overarm: "",
                Coat: "",
                CoatSize: "",
                Insleeve: "",
                Pant: "",
                PantSize: "",
                Shirt: "",
                ShirtSize: "",
                Sleeve: "",
                Vest: "",
                VestColor: "",
                outseam: "",
                Chest: "",
                Tie: "",
                hip: "",
                belt: "",
                Pocket: "",
                Jewelry: "",
                Shoes: "",
                ShoesSize: "",
                shirt_size: "",

                style: "",
                Waist: "",
                Rentalterm: "",
                // Other fields
                AlternatePickup: false,
                Affiliated_store: "",
                // Inventory IDs
                coatinventory_id: "",
                Paintinventory_id: "",
                shirtInventory_id: "",
                VestInventory_id: "",
                TieInventory_id: "",
                PocketInventory_id: "",
                jewelryinventory_id: "",
                ShoesInventory_id: "",
                size_chart_category_id: "",

                // Description
                Notes: "",
                SubmittedBy: "",
                NextSlip: ""
            });
            localStorage.removeItem('coatStyle');
            localStorage.removeItem('size');
            localStorage.removeItem('nonBoldMessage');
            localStorage.removeItem('selectedCoatSize');
            localStorage.removeItem('selectedCategoryName');
            localStorage.removeItem('allSize');
            localStorage.removeItem('Shoes');
            localStorage.removeItem('savedInsleeve');



            localStorage.removeItem('coatStyle');
            localStorage.removeItem('pantstyle');
            localStorage.removeItem('shirtstyle');
            localStorage.removeItem('Veststyle');
            localStorage.removeItem('size');
            localStorage.removeItem('coatid');
            setStep(1);
            setid(null)
            dispatch(clearSize());
            setIsSubmitting(false);

        }
        catch (error) {
            console.log(error, "error");
            toast.error(error.message || 'Failed to submit form. Please try again.', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                closeButton: false,
            });
            setIsSubmitting(false);

        }
    };

    window.addEventListener('beforeunload', () => {
        localStorage.removeItem('coatStyle');
        localStorage.removeItem('pantstyle');
        localStorage.removeItem('shirtstyle');
        localStorage.removeItem('Veststyle');
        localStorage.removeItem('size');
        localStorage.removeItem('coatid');
    });


    useEffect(() => {
        // alert("oooo")
        localStorage.removeItem('coatStyle');
        localStorage.removeItem('pantstyle');
        localStorage.removeItem('shirtstyle');
        localStorage.removeItem('Veststyle');
        localStorage.removeItem('size');
        localStorage.removeItem('coatid');
    }, [])

    const RestShirt = () => {
        // Reset form values using react-hook-form's setValue
        setShowShirt(false)
        setValue("shirtInventory_id", null);
        setValue("Shirt", "");
        // setValue("size_chart_category_id", null);
        // setValue("coat_size_chart_id", null);
        setValue("ShirtSize", "");
        setValue("Sleeve", "");

        // Update the formData state
        setFormData(prevData => ({
            ...prevData,
            shirtInventory_id: null,
            Shirt: "",
            // size_chart_category_id: null,
            // coat_size_chart_id: null,
            ShirtSize: "",
            Sleeve: ""
        }));
        localStorage.removeItem('shirtstyle');
        console.log(formData, "formData after reset");
    };
    const ResetVest = () => {
        setShowVest(false);
        setValue("VestInventory_id", null);
        setValue("Vest", "");
        // setValue("size_chart_category_id", null);  // If shared, already reset
        // setValue("coat_size_chart_id", null);      // If shared, already reset
        setValue("VestColor", "");

        setFormData(prevData => ({
            ...prevData,
            VestInventory_id: null,
            Vest: "",
            // size_chart_category_id: null,
            // coat_size_chart_id: null,
            VestColor: "",
        }));
        localStorage.removeItem('Veststyle');
    }


    const ResetShoe = () => {
        setShowShoes(false)
        setValue("ShoesInventory_id", null);
        setValue("Shoes", "");
        setValue("ShoesSize", "");
        setFormData(prevData => ({
            ...prevData,
            ShoesInventory_id: null,
            Shoes: "",
            ShoesSize: "",
        }));
    }

    const RecetTie = () => {
        setShowTie(false)
        setValue("TieInventory_id", null);
        setValue("Tie", "");

        setFormData(prevData => ({
            ...prevData,
            TieInventory_id: null,
            Tie: "",

        }));
    }

    const RecetPocket = () => {
        setShowPocket(false)
        setValue("PocketInventory_id", null);
        setValue("Pocket", "");

        setFormData(prevData => ({
            ...prevData,
            PocketInventory_id: null,
            Pocket: "",
        }));
    }
    const RecetCoat = () => {
        setValue("coatinventory_id", null);
        setValue("Coat", "");
        setValue("CoatSize", "");
        setValue("Insleeve", "");
        localStorage.removeItem('coatid');
        localStorage.removeItem('size');
        localStorage.removeItem('coatStyle');

        setFormData(prevData => ({
            ...prevData,
            coatinventory_id: null,
            Coat: "",
            CoatSize: "",
            Insleeve: "",
        }));
    }

    const RecetPant = () => {
        setShowPant(false)
        setValue("Paintinventory_id", null);
        setValue("Pant", "");
        setValue("Waist", "");
        setValue("hip", "");
        setValue("outseam", "");
        localStorage.removeItem('pantstyle');

        setFormData(prevData => ({
            ...prevData,
            Paintinventory_id: null,
            Pant: "",
            Waist: "",
            hip: "",
            outseam: "",


        }));


    }
    const ResetJewelry = () => {
        setShowjewelry(false)
        setValue("jewelryinventory_id", null);
        setValue("Jewelry", "");
        setFormData(prevData => ({
            ...prevData,
            jewelryinventory_id: null,
            Jewelry: "",

        }));
    }

    if (loading) {
        return (
            <Container>
                <div className="nk-content">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            <div className="nk-content-body">
                                <Loader /> {/* Your existing Loader component */}
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        );
    }
    console.log("[MultipleForm] Loaded formData.Insleeve:", formData?.Insleeve);

    return (
        <div>
            {step === 1 && (
                <AddEventiteam
                    key="step1"
                    onNext={onNextStep}
                    ticket={Singledata?.ticket || ""}
                    account={Singledata?.account || ""}
                    initialValues={{
                        Weddingdate: formData.Weddingdate,
                        order_type: formData.order_type,
                        AlterAcc: formData.AlterAcc,
                        AccountId: formData.AccountId,

                        Firstname: formData.Firstname,
                        Lastname: formData.Lastname,
                        Address: formData.Address,
                        State: formData.State,
                        City: formData.City,
                        ZipCode: formData.ZipCode,
                        PhoneNumber: formData.PhoneNumber,
                        EmailAddress: formData.EmailAddress,
                        school: formData.school,

                        dropShipping: formData.dropShipping,
                        dropShippingswitch: formData.dropShippingswitch,
                        AlternatePickup: formData.AlternatePickup,
                        Affiliated_store: formData.Affiliated_store,
                        store_id: formData.store_id,
                    }}

                />
            )}

            {step === 2 && (
                <AddMeasured
                    key="step3"
                    onNext={onNextStep}
                    onBack={onBackStep}
                    ticket={Singledata?.ticket || ""}
                    account={Singledata?.account || ""}
                    initialValues={{
                        Height: formData.Height,
                        Weight: formData.Weight,
                        Weightwo: formData.Weightwo,
                        Overarm: formData.Overarm,
                        Coat: formData.Coat,
                        belt: formData.belt,
                        CoatSize: formData.CoatSize,
                        Insleeve: formData.Insleeve,
                        Pant: formData.Pant,
                        Firstname: formData.Firstname,
                        Lastname: formData.Lastname,
                        PantSize: formData.PantSize,
                        Shirt: formData.Shirt,
                        ShirtSize: formData.ShirtSize,
                        shirt_size: formData.shirt_size,
                        shirtSizetype: formData?.shirtSizetype,
                        Sleeve: formData.Sleeve,
                        Vest: formData.Vest,
                        VestColor: formData.VestColor,
                        Tie: formData.Tie,
                        Pocket: formData.Pocket,
                        Jewelry: formData.Jewelry,
                        Shoes: formData.Shoes,
                        ShoesSize: formData.ShoesSize,
                        shoe_color: formData.shoe_color,
                        outseam: formData.outseam,
                        Chest: formData.Chest,
                        style: formData.style,
                        hip: formData.hip,
                        Rentalterm: formData.Rentalterm || "1 week",
                        order_for: formData.order_for,
                        Waist: formData.Waist,
                        size_chart_id: formData.size_chart_id,
                    }}
                />
            )}
            {step == 3 && (
                <Comment
                    key="step4"
                    onSubmit={onFormSubmit}
                    ticket={Singledata?.ticket || ""}
                    account={Singledata?.account || ""}
                    onBack={onBackStep}
                    isSubmitting={isSubmitting}
                    initialValues={{
                        Notes: formData.Notes,
                        SubmittedBy: formData.SubmittedBy,
                        NextSlip: formData.NextSlip,
                        Tie: formData.Tie,
                        order_for: formData.order_for,
                        Pant: formData.Pant,
                        shoe_color: formData.shoe_color,
                        belt: formData.belt,
                        Coat: formData.Coat,
                        Shirt: formData.Shirt,
                        Vest: formData.Vest,
                        dropShipping: formData.dropShipping,
                        dropShippingswitch: formData.dropShippingswitch,

                    }}
                />
            )}
            {/* const [CopyOrder, setCopyOrder] = useState(false) */}

            {step == 4 && (
                <OrderReview
                    key="step5"
                    onRewSubmit={onFinalSubmit}
                    onSubmit={onFormSubmit}
                    RestShirtSubmit={RestShirt}
                    ResetVest={ResetVest}
                    ResetShoe={ResetShoe}
                    ResetJewelry={ResetJewelry}
                    RecetTie={RecetTie}
                    RecetPocket={RecetPocket}
                    RecetCoat={RecetCoat}
                    RecetPant={RecetPant}
                    onBack={onBackStep}
                    refid={id}
                    showShirt={showShirt}
                    setShowShirt={setShowShirt}
                    showVest={showVest}
                    setShowVest={setShowVest}
                    showShoes={showShoes}
                    setShowShoes={setShowShoes}

                    setShowTie={setShowTie}
                    showTie={showTie}
                    setShowPocket={setShowPocket}
                    ShowPocket={ShowPocket}
                    CopyOrder={CopyOrder}
                    setCopyOrder={setCopyOrder}
                    setShowjewelry={setShowjewelry}
                    Showjewelry={Showjewelry}

                    Showcoat={Showcoat}
                    setShowcoat={setShowcoat}
                    isSubmitting={isSubmitting}

                    ShowPant={ShowPant}
                    setShowPant={setShowPant}
                    // initialValues={{
                    //     Notes: formData.Notes,
                    //     SubmittedBy: formData.SubmittedBy,
                    //     NextSlip: formData.NextSlip,
                    // }}
                    initialValues={{
                        Weddingdate: formData.Weddingdate,
                        order_type: formData.order_type,
                        Firstname: formData.Firstname,
                        Lastname: formData.Lastname,
                        Address: formData.Address,
                        State: formData.State,
                        City: formData.City,
                        ZipCode: formData.ZipCode,
                        PhoneNumber: formData.PhoneNumber,
                        EmailAddress: formData.EmailAddress,
                        school: formData.school,

                        dropShipping: formData.dropShipping,
                        dropShippingswitch: formData.dropShippingswitch,
                        AlternatePickup: formData.AlternatePickup,
                        Affiliated_store: formData.Affiliated_store,
                        store_id: formData.store_id,


                        Height: formData.Height,
                        Weight: formData.Weight,
                        Weightwo: formData.Weightwo,
                        Overarm: formData.Overarm,
                        Coat: formData.Coat,
                        CoatSize: formData.CoatSize,
                        Insleeve: formData.Insleeve,
                        Pant: formData.Pant,

                        PantSize: formData.PantSize,
                        Shirt: formData.Shirt,
                        ShirtSize: formData.ShirtSize,
                        Sleeve: formData.Sleeve,
                        Vest: formData.Vest,
                        VestColor: formData.VestColor,
                        Tie: formData.Tie,
                        Pocket: formData.Pocket,
                        Jewelry: formData.Jewelry,
                        Shoes: formData.Shoes,
                        ShoesSize: formData.ShoesSize,
                        outseam: formData.outseam,
                        Chest: formData.Chest,
                        style: formData.style,
                        hip: formData.hip,
                        Rentalterm: formData.Rentalterm,
                        order_for: formData.order_for,
                        Waist: formData.Waist,
                        size_chart_id: formData.size_chart_id,

                        Notes: formData.Notes,
                        SubmittedBy: formData.SubmittedBy,
                        NextSlip: formData.NextSlip,
                    }}


                />
            )}
        </div>
    )
}

export default MultipleForm
